import { Log, LogAction } from '../../../../../../models/Log';
import utils from '../../../../../../utils';
import { DescriptionCellComponent } from '../components/LogTableCellContent';

export const logTableColumns: Array<keyof Log> = [
  'username',
  'action',
  'description',
  'createdAt',
];
export const headingTranslationsLogTable = {
  username: 'Username',
  action: 'Action',
  description: 'Description',
  createdAt: 'Time',
};

export const ActionMapName: Record<LogAction, string> = {
  login: 'Login',
  'upload-file': 'Upload file',
  'get-all-files': 'Get all files',
  'download-file': 'Download file',
  'get-missing-file-data': 'Get missing file data',
  'Forbidden-file-access': 'Forbidden file access',
  'edit-file-download-expiration-days': 'Edit file expiration days',
  'delete-file': 'Delete file',
  'detect-screenshot': 'Screenshot detected',
  other: 'Other',
};

export const logTableCellContent = {
  action: (value: LogAction) => ActionMapName[value],
  description: (value: string) => (
    <DescriptionCellComponent description={value} />
  ),
  createdAt: (value: string) => utils.stringifyISODate(value),
};
